import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IResponse } from 'src/app/interface/response';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {

	constructor(
		private authService: AuthService,
		private httpClient: HttpClient
	) { }

	public answer(id: string, answered: boolean): Observable<IResponse> {
		if (!this.authService.company) {
			return this.httpClient.put<IResponse>(environment.apiUrl + '/notification/answer', {
				id,
				answered
			});
		}
		return this.httpClient.put<IResponse>(environment.apiUrl + '/{current_company_id}/notification/answer', {
			id,
			answered
		});
	}
}
